<template>
  <v-row>
    <v-col
      offset-y
      min-width="250px"
    >
      <v-dialog
        ref="dialog"
        v-model="modal2"
        :return-value.sync="localValue"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            prepend-inner-icon="mdi-clock-outline"
            hide-details
            outlined
            readonly
            v-model="formattedDate"
            :label="label"
            :class="inputClass"
            v-bind="attrs"
            v-on="on"
            @blur="onBlur"
          />
        </template>
        <v-time-picker
          v-if="modal2"
          v-model="localValue"
          full-width
          format="24hr"
          :allowed-minutes="allowedStep"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal2 = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(localValue)"
          >
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import DateUtils from './utils/date-formatter-utils';

export default {
  props: ['value', 'label', 'inputClass'],
  data() {
    return {
      menu2: false,
      modal2: false,
    };
  },
  methods: {
    onSelectDate(data) {
      this.localValue = data;
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    allowedStep: (m) => m % 5 === 0,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    formattedDate() {
      return DateUtils.formatTimeHourMinute(this.localValue);
    },
  },
};
</script>
